import Image from "next/image"

const MobileThumbOnPulse = () => {
  return (
    <div className="px-8 md:px-12">
      <div className="flex flex-col space-y-3 pb-5 justify-center items-center text-center">
        <p>Industry solutions specific to your business.</p>
        <p className="h4 sm:h3 text-text-color-high-em">
          Thumb on the pulse
        </p>
      </div>
      <div>
        <div className="flex flex-col justify-center items-center">
          <div className="p-5">
            <Image
              src="/images/industries/data-driven.png"
              alt="data-driven"
              width={400}
              height={272}
            />
          </div>
          <div className="flex flex-col space-y-5">
            <p className="h5 text-text-color-high-em-light">Data-driven solutions</p>
            <div className="text-text-color-mid-em-light flex flex-col space-y-5">
              <p>
                Our industry solutions portfolio utilizes a wide array of options specific to your business, waste profiles, and facility type.
                Find the solution that&apos;s right for you.
              </p>
            </div>
          </div>
        </div>
        <div className="flex pt-10 flex-col justify-center items-center ">
          <div className="px-5">
            <Image
              src="/images/industries/mobile-tech-integ.png"
              alt="tech-integ"
              width={399}
              height={336}
            />
          </div>
          <div className="flex flex-col space-y-5">
            <p className="h5 text-text-color-high-em-light">
              Technology Integration
            </p>
            <div className="text-text-color-mid-em-light flex flex-col space-y-5">
              <p>
                Power your operations with our technology stack.
                Consolidate the management of your programs, services, and vendors with our platform.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileThumbOnPulse;